import React from 'react';

export default (props) =>
	<div className='year-selector' style={props.style}>
		<i className="material-icons" onClick={(e) => props.onChange(props.value-1)}>chevron_left</i>
		<div className='value'>{props.value}</div>
		<i className="material-icons" onClick={(e) => props.onChange(props.value+1)}>chevron_right</i>
	</div>
